<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="languages"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    multiple chips dark autocomplete>
  </v-select>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    computed: mapGetters({
      languages: 'application/languages'
    }),
    methods: mapActions({
      fetchLanguages: 'application/fetchLanguages'
    }),
    beforeMount () {
      this.fetchLanguages()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Language.vue